/* Bundle Pricing — scroll-triggered reveal, idempotent per Shopify section lifecycle. */
(function () {
  var SELECTOR = '[data-section-type="bundle-pricing"]';

  function applyDelays(container) {
    container.querySelectorAll('[data-bp-reveal]').forEach(function (el) {
      var delay = el.getAttribute('data-bp-delay');
      if (delay && !el.style.getPropertyValue('--bp-delay')) {
        el.style.setProperty('--bp-delay', delay + 'ms');
      }
    });
  }

  function init(container) {
    if (!container || container.dataset.bound === 'true') return;
    container.dataset.bound = 'true';

    applyDelays(container);

    var targets = container.querySelectorAll('[data-bp-reveal]');
    if (!targets.length) return;

    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });

    targets.forEach(function (el) { observer.observe(el); });

    container._bpCleanup = function () {
      observer.disconnect();
    };
  }

  function destroy(container) {
    if (!container) return;
    if (typeof container._bpCleanup === 'function') container._bpCleanup();
    container.dataset.bound = '';
  }

  document.querySelectorAll(SELECTOR).forEach(init);

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.matches && e.target.matches(SELECTOR)) init(e.target);
    e.target.querySelectorAll && e.target.querySelectorAll(SELECTOR).forEach(init);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    if (e.target.matches && e.target.matches(SELECTOR)) destroy(e.target);
    e.target.querySelectorAll && e.target.querySelectorAll(SELECTOR).forEach(destroy);
  });
})();
